module.exports = __webpack_public_path__ + "img/greenchip.b96b3304.svg";